import { createAsyncThunk } from "@reduxjs/toolkit";

import { animateCss } from "../../../pages/TosterAlert";
import {
  checkUniqueness,
  createBranch,
  deleteBranch,
  getAllBranches,
  organizationBranchStatus,
  toggleBranchStatus,
  updateBranch,
} from "../../../api/organizationBranch_api";
import { useDispatch } from "react-redux";

// Check branch uniqueness
export const checkBranchUniquenessAction = createAsyncThunk(
  "branches/checkUniqueness",
  async (data, { rejectWithValue }) => {
    try {
      return await checkUniqueness(data);
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        details: error.details || null,
      });
    }
  }
);

// Create branch
export const createBranchAction = createAsyncThunk(
  "branches/create",
  async (branchData, { rejectWithValue }) => {
    try {
      return await createBranch(branchData);
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        details: error.details || null,
      });
    }
  }
);

// Update branch
export const updateBranchAction = createAsyncThunk(
  "branches/update",
  async (values, { rejectWithValue }) => {
    try {
      return await updateBranch(values);
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        details: error.details || null,
      });
    }
  }
);

// Toggle branch status
export const organizationBranchStatusAction = createAsyncThunk(
  "branches/Status",
  async ({ id }, { rejectWithValue }) => {
    try {
      return await organizationBranchStatus(id);
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        details: error.details || null,
      });
    }
  }
);

// Delete branch
export const deleteBranchAction = createAsyncThunk(
  "branches/delete",
  async ({ id }, { rejectWithValue }) => {
    try {
      const result = await deleteBranch(id);

      if (result.success) {
        animateCss(
          "success",
          result.message || "Branch deleted successfully",
          3000
        );
      } else {
        animateCss("error", result.message || "Branch not deleted ", 3000);
      }
      return result;
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        details: error.details || null,
      });
    }
  }
);

// Get all branches
export const fetchAllBranchesAction = createAsyncThunk(
  "branches/fetchAll",
  async (values, { rejectWithValue }) => {
    try {
      return await getAllBranches(values);
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        details: error.details || null,
      });
    }
  }
);
